import { TFunction } from 'i18next';
import numbro from 'numbro';

import * as Types from '../shared/types';

export default {
  optionToString,
  groupsForGroupBy,
};

function optionToString(t: TFunction) {
  return function (option: Types.SignalOption): string {
    const conditions = option.conditions;
    if (conditions.length === 0) return t('Any value');
    return conditions
      .map(
        (condition: Types.SignalCondition) =>
          `${condition.operator} ${numbro(condition.value).format('0.%')}`
      )
      .join(` ${t('&&')} `);
  };
}

function groupsForGroupBy(t: TFunction) {
  return (groupBy: string): string[] => {
    switch (groupBy) {
      case 'none': {
        return [t('All')];
      }
      case 'bluestack': {
        return [t('Bluestack'), t('Others')];
      }
      case 'bb': {
        return ['<-2', '-2-0', '0-2', '>2'];
      }
      case 'mktcap': {
        return [t('<1T'), t('1T-5T'), t('5T-30T'), t('>30T')];
      }
      case 'rsi': {
        return ['<30', '30-50', '50-70', '>70'];
      }
      case 'dev': {
        return ['<0.02', '0.02-0.04', '0.04-0.06', '>= 0.06'];
      }
      case 'rp180':
      case 'rp360': {
        return [
          t('lowest quarter'),
          t('lower quarter'),
          t('upper quarter'),
          t('highest quarter'),
        ];
      }
      default: {
        return ['All'];
      }
    }
  };
}
